<template>
  <div class="kofi-widget-container"></div>
</template>

<script>
export default {
    props: {
        kofiId: {
        type: String,
        default: 'facecageco'
        },
        buttonColor: {
        type: String,
        default: '#000000'
        },
        buttonText: {
        type: String,
        default: 'Support Us'
        }
   },
  mounted() {
    // Create script element
    const script = document.createElement('script');
    script.src = 'https://storage.ko-fi.com/cdn/scripts/overlay-widget.js';
    script.onload = () => {
      // Initialize Ko-fi widget when script is loaded
      window.kofiWidgetOverlay.draw(this.kofiId, {
        'type': 'floating-chat',
        'floating-chat.donateButton.text': this.$props.buttonText,
        'floating-chat.donateButton.background-color': this.$props.buttonColor,
        'floating-chat.donateButton.text-color': '#fff',

        'floating-chat.position': 'right',
        'floating-chat.corner.right': '20', 
        'floating-chat.corner.bottom': '70'
      });
    };
    
    document.body.appendChild(script);
  },
  beforeUnmount() {
    // Clean up when component is destroyed
    const kofiContainer = document.getElementById('kofi-widget-overlay');
    if (kofiContainer) {
      kofiContainer.remove();
    }
  }
}
</script>

<style scoped>
.kofi-widget-container {
  /* Any custom styling for the container */
}
</style>